import React from 'react';
import styled from 'styled-components';
import { CardColor } from '../../types';

interface ColorSelectorProps {
  currentColor: string;
  onColorSelect: (color: CardColor) => void;
}

// 色選択コンテナ
const SelectorContainer = styled.div`
  display: flex;
  gap: 5px;
`;

// 色選択オプション
const ColorOption = styled.div<{ $color: string; $isSelected: boolean }>`
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: ${props => props.$color};
  cursor: pointer;
  border: ${props => (props.$isSelected ? '2px solid #333' : '1px solid #ccc')};
`;

// 利用可能な色のオプション
const colorOptions: { color: CardColor; hex: string }[] = [
  { color: 'white', hex: '#ffffff' },
  { color: 'blue', hex: '#bbdefb' },
  { color: 'green', hex: '#c8e6c9' },
  { color: 'yellow', hex: '#fff9c4' },
  { color: 'red', hex: '#ffcdd2' },
  { color: 'purple', hex: '#e1bee7' },
];

const ColorSelector: React.FC<ColorSelectorProps> = ({ currentColor, onColorSelect }) => {
  return (
    <SelectorContainer>
      {colorOptions.map((option) => (
        <ColorOption
          key={option.color}
          $color={option.hex}
          $isSelected={currentColor === option.hex}
          onClick={(e) => {
            e.stopPropagation();
            onColorSelect(option.color);
          }}
        />
      ))}
    </SelectorContainer>
  );
};

export default ColorSelector; 